export const Module = {
  DASHBOARD: "dashboard",
  POSITION_MONITORING: "position-monitoring",
  POSITION_SINGLE_LOCATION: "position-monitoring--single-location",
  POSITION_ALL_LOCATIONS: "position-monitoring--all-locations",
  POSITION_COMPETITION_COMPARISON:
    "position-monitoring--competition-comparison",
  USERS_BEHAVIOR: "user-behavior",
  ANALYTICS_COMPARISON: "analytics-comparison",
  LOCATIONS: "locations",
  LOCATIONS_MANAGE: "locations--manage",
  LOCATIONS_QUALITY: "locations--quality",
  EXTERNAL_CHANGES: "external-changes",
  EXTERNAL_CHANGES_LIST: "external-changes--list",
  EXTERNAL_CHANGES_PROTECT: "external-changes--protect",
  EXTERNAL_CHANGES_HISTORY: "external-changes--history",
  PHOTOS: "photos",
  PHOTOS_SENT: "photos--sent",
  PHOTOS_USERS: "photos--users",
  POSTS: "posts",
  REVIEWS: "reviews",
  REVIEWS_LIST: "reviews--list",
  REVIEWS_ANALYTICS: "reviews--analytics",
  REVIEWS_CATEGORIES_ANALYTICS: "reviews--categories-analytics",
  TEAM: "team",
  SETTINGS: "settings",
  SETTINGS_COMPANY: "settings-company",
  SETTINGS_KEYWORDS: "settings-keywords",
  SETTINGS_GMB_ACCOUNTS: "settings-gmb-accounts",
  SETTINGS_MAP_CONFIG: "settings-map-settings",
  SETTINGS_COMPETITION_LOCATIONS: "settings-competition-locations",
  SETTINGS_FACEBOOK_ACCOUNTS: "facebook-accounts",
  SETTINGS_APPLE_ACCOUNTS: "apple-accounts",
  SETTINGS_APPS_CONFIG: "mobile-apps",
  STORE_LOCATOR: "store-locator",
  REVIEW_BOOSTER: "review-booster",
  REVIEW_BOOSTER_FORM_LIST: "review-booster-form-list",
  REVIEW_BOOSTER_REVIEWS: "review-booster-reviews",
  QUESTIONS_AND_ANSWERS: "questions-and-answers",
  REVIEWS_COMPETITION_COMPARISON: "reviews-competition-comparison",
  APP_REVIEWS: "app-reviews",
  REVIEW_BOOSTER_STATISTICS: "review-booster-statistics",
  SEARCH_KEYWORDS: "search-keywords"
};
